import { Component } from 'react';
import { Modal } from 'antd';
import { inject } from 'mobx-react';
import { ClassNames, toggleGlobalScroll } from '@/utils';
import styles from './index.module.less';

/**
 *
 * @param {Boolean} disabledToggleScroll 禁用切换滚动条状态（禁用之后会导致滚动透传）
 */
@inject('area')
class InstaModal extends Component {
  handleCancel = () => {
    const { onCancel, disabledToggleScroll } = this.props;

    !disabledToggleScroll && toggleGlobalScroll(false);
    onCancel && onCancel();
  };

  render() {
    const {
      onConfirm,
      maskClosable,
      hideHeaderBorder = false,
      centered = true,
      visible,
      title,
      headerVisible = true,
      closable = true,
      children,
      wrapClassName,
      cancelText,
      confirmText,
      showBtnCt,
      showCancel = true,
      showConfirm = true,
      width = '480px',
      theme,
      titleAlign = 'left',
      titleBorder = true,
      stepAllow = false, // 步骤弹窗标记
      onStepPrev, // 向前的步骤
      disabledToggleScroll = false,
      ...restProps
    } = this.props;
    const { LANG } = this.props.area;
    if (typeof window === 'undefined') return null;
    if (visible) {
      !disabledToggleScroll && toggleGlobalScroll(true);
    } else {
      !disabledToggleScroll && toggleGlobalScroll(false);
      return null;
    }
    return (
      <Modal
        visible={visible}
        width={width}
        closable={false}
        maskClosable={maskClosable || false}
        footer={null}
        wrapClassName={`${styles.MiddleModal} ${wrapClassName || ''} ${theme === 'float' ? styles.float : ''}`}
        title=''
        centered={centered}
        onCancel={this.handleCancel}
        keyboard={false}
        {...restProps}
      >
        <div className={styles.main}>
          {headerVisible && (
            <div
              className={ClassNames([
                styles.header,
                !title ? styles.hideTitle : '',
                titleAlign === 'left' ? '' : styles.center,
                titleBorder ? '' : styles.noBorder,
              ])}
              data-hide-border={hideHeaderBorder}
            >
              {stepAllow && <div className={styles.stepLeft} onClick={onStepPrev} />}
              <div className={styles.title}>{title || ''}</div>
              {closable && (
                <button className={styles.btnClose} onClick={this.handleCancel}>
                  {' '}
                  ×{' '}
                </button>
              )}
            </div>
          )}
          <div className={styles.content} data-hide-border={hideHeaderBorder}>
            {children}
          </div>
          {showBtnCt && (
            <div className={styles.footer}>
              {showCancel && (
                <button onClick={this.handleCancel} className={styles.btnCancel}>
                  {cancelText || LANG['common.btn.cancel']}
                </button>
              )}
              {showConfirm && (
                <button onClick={onConfirm} className={styles.btnConfirm}>
                  {confirmText || LANG['common.btn.confirm']}
                </button>
              )}
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default InstaModal;
